import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import Toast from 'utils/toast';
import IconMainContainer from 'components/IconMainContainer';
import useCurrentProfile from './useCurrentProfile';
import useIsInfluencer from './useIsInfluencer';

const useConfirmationRedirect = (path = '/') => {
  const loggedIn = useSelector(state => state.auth.loggedIn);
  const currentUser = useSelector(state => state.auth.currentUser);
  const profile = useCurrentProfile();
  const router = useRouter();
  const isInfluencer = useIsInfluencer();

  useEffect(() => {
    router.prefetch(path);
  }, [path, router]);

  useEffect(() => {
    if (loggedIn && !currentUser.confirmed) {
      Toast('error', `You need to confirm your account first.`, {
        icon: <IconMainContainer src="/icons/notifications/times.svg" alt="Times" errorStyle />,
      });

      router.push(path);
    } else if (
      loggedIn &&
      isInfluencer &&
      currentUser.confirmed &&
      !profile?.completed &&
      currentUser.primary_interest !== 'buy'
    ) {
      Toast('error', 'You need to set up your inventory first.', {
        icon: <IconMainContainer src="/icons/notifications/times.svg" alt="Times" errorStyle />,
      });

      router.push(path);
    }
  }, [
    loggedIn,
    router,
    isInfluencer,
    path,
    currentUser.confirmed,
    profile?.completed,
    currentUser.primary_interest,
  ]);
};

export default useConfirmationRedirect;
